<template>
    <v-app
        :dark="darkMode"
        id="inspire"
        :class="[
            {
                'box-layout': boxLayout,
                'collapse-sidebar': collapseSidebar,
                'rtl-layout': rtlLayout,
            },
        ]"
    >
        <bc-progress-loader></bc-progress-loader>
        <router-view :auth="auth" :authenticated="authenticated" class="white-bg"></router-view>
        <notifications group="loggedIn" position="top center" animation-type="velocity" />
    </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import Vue from "vue";
import AuthService from "Auth/AuthService";
import BcProgressLoader from "Components/ProgressLoader/BcProgressLoader.vue";

const auth = new AuthService();

const { login, logout, authenticated, authNotifier } = auth;

export default {
    components: {
        BcProgressLoader,
    },
    data() {
        authNotifier.on("authChange", (authState) => {
            this.authenticated = authState.authenticated;
        });
        return {
            auth,
            authenticated,
            animation: {
                enter: {
                    opacity: [1, 0],
                    translateX: [0, -300],
                    scale: [1, 0.2],
                },
                leave: {
                    opacity: 0,
                    height: 0,
                },
            },
            loader_timer: null,
            modal_timer: null,
            sidebar_timer: null,
            special_timer: null,
        };
    },
    mounted() {
        if (this.selectedLocale.locale === "he" || this.selectedLocale.locale === "ar") {
            this.$store.dispatch("rtlLayout");
        }
    },
    computed: {
        ...mapGetters([
            "darkMode",
            "collapseSidebar",
            "boxLayout",
            "rtlLayout",
            "selectedLocale",
            "progressLoaderWidth",
            "modal_loader",
            "sidebar_loader",
            "special_loader",
            "current_tour",
        ]),
    },
    watch: {
        // if loader is turned on, automatically turn off at set limit
        progressLoaderWidth: function (newVal, oldVal) {
            if (newVal == 100) {
                this.loader_timer = setTimeout(() => {
                    this.createAlert();
                    this.$store.dispatch("hideLoader");
                    //this.$store.commit('finishLoader');
                }, 8000); // 5 seconds after load is stuck at 100% create alert
            } else if (newVal == 0) {
                clearTimeout(this.loader_timer);
            }
        },
        // if modal loader is turned on, automatically turn off at set limit
        modal_loader: function (newVal, oldVal) {
            if (newVal == true) {
                this.modal_timer = setTimeout(() => {
                    this.createAlert();
                    this.$store.commit("toggleModalLoader", false);
                    this.$root.$emit("escapePressed");
                }, 20000); // 20 seconds
            } else {
                clearTimeout(this.modal_timer);
            }
        },
        // if sidebar loader is turned on, automatically turn off at set limit
        sidebar_loader: function (newVal, oldVal) {
            if (newVal == true) {
                this.sidebar_timer = setTimeout(() => {
                    this.createAlert();
                    this.$store.commit("toggleSidebarLoader", false);
                }, 10000); // 10 seconds
            } else {
                clearTimeout(this.sidebar_timer);
            }
        },
        // if special loader is turned on, automatically turn off at set limit
        special_loader: function (newVal, oldVal) {
            if (newVal == true) {
                this.special_timer = setTimeout(() => {
                    this.createAlert();
                    this.$store.commit("toggleSpecialLoader", false);
                }, 10000); // 10 seconds
            } else {
                clearTimeout(this.special_timer);
            }
        },
    },
};
</script>
